import type { TodoFolderDescriptor } from '../../schema/TodoFolderDescriptor';
import type { Todo } from 'owa-todo-types';
import { andFilters } from './combineFilters';
import type { TodoFilterFunction } from '../../schema/TodoFilterFunction';
import { buildIsCompleteFilter } from './buildIsCompleteFilter';

export function buildTodoFolderDescriptorFilter(
    todoFolderDescriptor: TodoFolderDescriptor
): TodoFilterFunction {
    const filters = [buildFolderIdFilter(todoFolderDescriptor.folderId)];
    if (todoFolderDescriptor.isComplete !== undefined) {
        filters.push(buildIsCompleteFilter(todoFolderDescriptor.isComplete));
    }
    return andFilters(filters);
}

function buildFolderIdFilter(folderId: string): TodoFilterFunction {
    return (todo: Todo) => todo.ParentFolderId === folderId;
}
